<template>
  <header class="checkout-header-component">
    <section>
      <div class="col-left">
        <NuxtLink :to="homeLink.route">
          <img :src="homeLink.image" class="logo" :alt="homeLink.text" />
        </NuxtLink>
        <DarkMode />
      </div>
      <div class="col-middle">
        <template v-if="!loaderStore.getLoader">
          <div class="checkout-steps-wrap" :class="`step-${step}`">
            <div class="checkout-steps">
              <div class="checkout-step checkout-step-1">
                <span class="checkout-step-done"><i class="fa-solid fa-circle-check"></i></span>
                <span class="checkout-step-number">1</span>
                <span class="checkout-step-title">{{ t('checkout.header.delivery') }}</span>
              </div>
              <div class="checkout-step-arrow arrow-1">
                <i class="fa-solid fa-chevron-right"></i>
              </div>
              <div class="checkout-step checkout-step-2">
                <span class="checkout-step-done"><i class="fa-solid fa-circle-check"></i></span>
                <span class="checkout-step-number">2</span>
                <span class="checkout-step-title">{{ t('checkout.header.payment') }}</span>
              </div>
              <div class="checkout-step-arrow arrow-2">
                <i class="fa-solid fa-chevron-right"></i>
              </div>
              <div class="checkout-step checkout-step-3">
                <span class="checkout-step-done"><i class="fa-solid fa-circle-check"></i></span>
                <span class="checkout-step-number">3</span>
                <span class="checkout-step-title">{{ t('checkout.header.confirmation') }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="col-right">
        <template v-if="!loaderStore.getLoader">
          <div v-if="false" class="checkout-counter">
            <!-- @TODO: Disabled by request -->
            <CheckoutCounter :heading="t('checkout.header.left_till_update')" />
          </div>
        </template>
      </div>
    </section>
  </header>
</template>

<script lang="ts" setup>
import Logo from '@/assets/images/logo.svg'
import { useCheckoutStore } from '~/store/checkout'
import { useLang } from '~/composables/useLang'
import { Routes } from '~/enums/Routes'
import getLocalizedRoute from '~/utils/getLocalizedRoute'
import CheckoutCounter from '~/components/Checkout/CheckoutCounter.vue'
import { useLoaderStore } from '~/store/loader'

const { t } = useLang()
const checkoutStore = useCheckoutStore()
const loaderStore = useLoaderStore()

const step = computed(() => checkoutStore.step)

const homeLink = computed(() => ({
  text: `Site Logo`,
  image: Logo,
  route: getLocalizedRoute(Routes.Index),
}))
</script>

<style lang="postcss" scoped>
.checkout-header-component {
  @apply flex justify-center py-4 xl:py-8 px-2 lg:px-4;
  section {
    @apply flex items-center max-w-xlg w-full lg:px-[15px] gap-4 flex-wrap xl:flex-nowrap;
    .col-left {
      @apply flex basis-full xl:basis-1/5 justify-center xl:justify-start;

      .logo {
        @apply dark:invert;
      }
    }
    .col-middle {
      @apply flex basis-full xl:basis-3/5 justify-center gap-4;
    }
    .col-right {
      @apply hidden xl:flex basis-full xl:basis-1/5 justify-end ml-auto xl:ml-0;
    }
  }
  .checkout-steps-wrap {
    @apply h-[2.75rem] rounded-full p-[1px];
    .checkout-steps {
      @apply flex items-center gap-4 p-[0.5625rem] bg-white dark:bg-dmGray1 rounded-full;
      .checkout-step {
        @apply flex items-center gap-2 text-xs text-gray0 dark:text-dmText3;
        .checkout-step-number {
          @apply flex items-center justify-center rounded-full border-solid h-[1.5rem] w-[1.5rem] bg-gray1 dark:bg-dmGray2 font-medium;
        }
        .checkout-step-title {
          @apply hidden xl:flex;
        }
        .checkout-step-done {
          @apply hidden text-[1.5rem] leading-none;
        }
      }
      .checkout-step-arrow {
        @apply text-neutral3 dark:text-dmText3 text-xs;
      }
    }
    &.step-3 {
      background: linear-gradient(to right, theme('colors.purple') 0, theme('colors.gray3') 33.33%);
      .checkout-step {
        &.checkout-step-1 {
          @apply text-purple;
          .checkout-step-number {
            @apply border border-purple bg-purple text-white dark:text-black;
          }
          .checkout-step-title {
            @apply flex;
          }
        }
      }
    }
    &.step-4 {
      background: linear-gradient(to right, theme('colors.purple') 0, theme('colors.gray3') 66.66%);
      .checkout-steps {
        .checkout-step {
          &.checkout-step-1 {
            @apply text-purple;
            .checkout-step-done {
              @apply flex text-purple;
            }
            .checkout-step-number {
              @apply hidden;
            }
          }
          &.checkout-step-2 {
            @apply text-purple;
            .checkout-step-number {
              @apply border border-purple bg-purple text-white dark:text-black;
            }
            .checkout-step-title {
              @apply flex;
            }
          }
        }
      }
    }
    &.step-5 {
      background: linear-gradient(to right, theme('colors.purple') 66.66%, theme('colors.purple'));
      .checkout-steps {
        .checkout-step {
          &.checkout-step-1 {
            @apply text-purple;
            .checkout-step-done {
              @apply flex text-purple;
            }
            .checkout-step-number {
              @apply hidden;
            }
          }
          &.checkout-step-2 {
            @apply text-purple;
            .checkout-step-done {
              @apply flex text-purple;
            }
            .checkout-step-number {
              @apply hidden;
            }
          }
          &.checkout-step-3 {
            @apply text-purple;
            .checkout-step-number {
              @apply border border-purple bg-purple text-white dark:text-black;
            }
            .checkout-step-title {
              @apply flex;
            }
          }
        }
      }
    }
  }
  .checkout-counter {
    @apply flex items-center h-[2.75rem] rounded-full bg-gray1 dark:bg-dmGray1 px-1;
  }
}
</style>
